var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99997 1.41406C7.99997 2.11026 7.31003 3.15206 6.61257 4.027C5.71443 5.15346 4.64257 6.13753 3.41263 6.88886C2.49123 7.45146 1.37237 7.99153 0.473568 7.99153M7.99997 14.5853C7.99997 13.8891 7.31003 12.8473 6.61257 11.9723C5.71443 10.8459 4.64257 9.8618 3.41263 9.11046C2.49123 8.54786 1.37237 8.0078 0.473568 8.0078M0.473568 7.99966H15.5264",
    stroke: "#0D0D0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroArrowLeft);
export default __webpack_public_path__ + "static/media/hero-arrow-left.74f516035608ec98f116b29b890dd862.svg";
export { ForwardRef as ReactComponent };